module.exports = __webpack_public_path__ + "img/inverter_classic.f13a8517.png";